import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BillingScope } from '../../../billing-consts';
import { BadgeComponent } from '../../../components/badge/badge.component';
import { UpgradeBadgeComponent } from '../../../shared-extra/components/pro-tag/upgrade-badge.component';

@Component({
  selector: 'app-gallery-settings-group',
  imports: [UpgradeBadgeComponent, BadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-settings-group.component.html',
  styleUrl: './gallery-settings-group.component.scss',
})
export class GallerySettingsGroupComponent {
  title = input<string>();
  location = input<string>();
  scope = input<BillingScope>();
  comingSoon = input<boolean>(false);
  beta = input<boolean>(false);
  small = input<boolean>(false);
  noContentPadding = input<boolean>(false);
}
